import { render, staticRenderFns } from "./UsageSummary.vue?vue&type=template&id=010f2b88&scoped=true"
import script from "./UsageSummary.vue?vue&type=script&lang=js"
export * from "./UsageSummary.vue?vue&type=script&lang=js"
import style0 from "./UsageSummary.vue?vue&type=style&index=0&id=010f2b88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010f2b88",
  null
  
)

export default component.exports